import React from 'react';

export default function AboutUsLogo({ imgPath, logoPath }) {
    return (
        <div className="position-relative">
            <img src={imgPath} className="tw-mx-auto" alt="overlap"></img>
            <img src={logoPath} className="tw-mx-auto position-absolute tw-bottom-0 tw-right-20" alt="overlap"></img>
        </div>
    )
}